var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticClass:"cls-1",attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"},on:{"click":_vm.log}},[_c('defs'),_c('path',{attrs:{"d":_vm.iconPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }